var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.291,
    height: 22,
    viewBox: "0 0 28.291 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#afafaf;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.755,37.757,4.7,45.215v8.049a.786.786,0,0,0,.786.786l5.5-.014a.786.786,0,0,0,.782-.786v-4.7a.786.786,0,0,1,.786-.786H15.7a.786.786,0,0,1,.786.786v4.7a.786.786,0,0,0,.786.788l5.5.015a.786.786,0,0,0,.786-.786V45.21l-9.053-7.452a.6.6,0,0,0-.751,0Zm14.3,5.069-4.106-3.384v-6.8a.589.589,0,0,0-.589-.589h-2.75a.589.589,0,0,0-.589.589v3.566l-4.4-3.618a2.357,2.357,0,0,0-3,0L.2,42.826a.589.589,0,0,0-.079.83l1.252,1.522a.589.589,0,0,0,.83.08l11.552-9.515a.6.6,0,0,1,.751,0l11.553,9.515a.589.589,0,0,0,.83-.079l1.252-1.522a.589.589,0,0,0-.083-.831Z",
    transform: "translate(0.015 -32.05)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSolid);
export default __webpack_public_path__ + "static/media/home-solid.afd449df.svg";
export { ForwardRef as ReactComponent };